import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { BafAgentService } from '../../../core/services/baf-agent/baf-agent.service';
import { DataStoreService } from '../../../core/services/data-store/data-store.service';

@Injectable()
export class AuthService implements OnDestroy {
  userName: string;
  private isAlive = true;
  private isAuthenticated = new BehaviorSubject<boolean>(false);

  redirectUrl: string;

  constructor(
    private bafAgent: BafAgentService,
    private router: Router,
    private dataStore: DataStoreService
  ) {}

  get isAuthenticatedValue(): boolean {
    return this.isAuthenticated.getValue();
  }

  get isAuthenticatedStream(): Observable<boolean> {
    return this.isAuthenticated.asObservable();
  }

  login(): void {
    this.router.navigate(['/login']);
  }

  logout(): void {
    window.location.href = this.bafAgent.logoutUrl;
    /*this.bafAgent.logout().subscribe(
      () => {
        setTimeout(() => this.router.navigate(['/login']), 1000);
      },
      () => {
        setTimeout(() => this.router.navigate(['/login']), 1000);
      }
    );*/
  }

  verify(): void {
    this.checkAutorization();
  }

  private checkAutorization(): void {
    this.bafAgent.getUserState().subscribe(
      userState => {
        this.isAuthenticated.next(userState.isAuthenticated);
        if (userState.isAuthenticated) {
          this.userName = userState.userName;
          this.router.navigate(['/main']);
        } else {
          window.location.href = this.dataStore.apiUrl;
        }
      },
      () => {
        this.dataStore.setErrorId(4);
        this.router.navigate(['/error'])
      }
    );
  }

  ngOnDestroy() {
    this.isAlive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/services/auth/auth.service.ts